import React, { useCallback, useEffect } from 'react';
import { batch, useDispatch } from 'react-redux';
import { Icon } from '@vectord/components';

import {
  EDIT_PAUSE_DURATION_MODAL_STAGES,
  setEditDurationModalStage,
  setSelectedRequest,
} from 'features/courseResume';
import styles from './EditDurationModalSuccessStage.module.scss';

function EditDurationModalSuccessStage() {
  const dispatch = useDispatch();

  const handleModalClose = useCallback(() => {
    batch(() => {
      dispatch(setSelectedRequest(null));
      dispatch(
        setEditDurationModalStage(EDIT_PAUSE_DURATION_MODAL_STAGES.notOpen)
      );
    });
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleModalClose();
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [dispatch, handleModalClose]);

  return (
    <div className={styles.root}>
      <div className={styles.success}>
        <Icon
          name="tick-circle"
          className="h3 success bold m-b-xs"
        />
        <div className="h4">Duration Updated Successfully</div>
      </div>
    </div>
  );
}

export default EditDurationModalSuccessStage;
